<span floori-dialog-title>
    <ng-content></ng-content>
</span>
<button floori-icon-button class="small outline no-border" floori-dialog-close>
    <floori-icon name="fl_close"></floori-icon>
</button>
